import ApiService, { ApiError } from "./api/api.service";

const MIN_SLEEP = 2000;
const MAX_SLEEP = 5000;

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export default class BackgroundService {
  private static instance: BackgroundService;

  public static getInstance(): BackgroundService {
    if (!BackgroundService.instance) {
        BackgroundService.instance = new BackgroundService();
    }

    return BackgroundService.instance;
  }

  constructor() {
  }


  public async waitForJob(
    jobId: string, 
    fastest_result: boolean = false,
    onProgress?: (progress: any) => void,
    ignore_404: boolean = false,
  ) {
    let jobStatus = 'queued';
    let resp: any;
    let iteration = 1;

    while (['queued', 'started', 'deferred', 'scheduled'].includes(jobStatus)) {
      if (iteration > 120) {
        throw new Error('Max wait for job exceeded')
      }
      
      let sleepFor = (fastest_result) ? 1000 : iteration * 1000;
      if (sleepFor < MIN_SLEEP) {
        sleepFor = MIN_SLEEP;
      }
      if (sleepFor > MAX_SLEEP) {
        sleepFor = MAX_SLEEP;
      }
      
      await sleep(sleepFor);
      try {
        resp = await ApiService.getInstance().request('GET', `/get-job-status/${jobId}`);
        jobStatus = resp.job_status;
        
        // Report progress if callback provided and progress data exists
        if (onProgress && resp.progress) {
          onProgress({
            status: jobStatus,
            progress: resp.progress,
            iteration,
            // Include any other useful info from resp.meta
            meta: resp.meta
          });
        }
      } catch (err) {
        // If we get a 404, assume it's an old job that's already been cleaned up
        if (err instanceof ApiError && err.code === 404 && ignore_404) {
          return null; // or return some default value indicating old job
        }
        // Re-throw any other errors
        throw err;
      }
      iteration += 1;
    }

    if (resp.job_status === 'failed') {
      throw new Error(resp.error_message || 'Job failed');
    }

    return resp.job_result;
  }
}
